const data = [
  {
    id: 1,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45007",
    price: 6290,
    img: "./images/menpage1.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 2,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45008",
    price: 4250,
    img: "./images/menpage2.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 3,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45009",
    price: 5890,
    img: "./images/menpage3.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 4,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45010",
    price: 5890,
    img: "./images/menpage4.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 5,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45015",
    price: 5390,
    img: "./images/menpage5.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 6,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45018",
    price: 5390,
    img: "./images/menpage6.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 7,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45020",
    price: 5390,
    img: "./images/menpage7.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },

  {
    id: 8,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45021",
    price: 5390,
    img: "./images/menpage8.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 9,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45022",
    price: 5390,
    img: "./images/menpage9.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 10,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45023",
    price: 1890,
    img: "./images/menpage10.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },

  {
    id: 11,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45024",
    price: 1890,
    img: "./images/menpage11.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 12,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45025",
    price: 1890,
    img: "./images/menpage12.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 13,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45026",
    price: 1890,
    img: "./images/menpage13.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 14,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45027",
    price: 1890,
    img: "./images/menpage14.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 15,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45028",
    price: 2500,
    img: "./images/menpage15.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 16,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45029",
    price: 2500,
    img: "./images/menpage16.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 17,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45030",
    price: 7250,
    img: "./images/menpage17.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 18,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45031",
    price: 1590,
    img: "./images/menpage18.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 19,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45032",
    price: 1590,
    img: "./images/menpage19.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 20,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45033",
    price: 1590,
    img: "./images/menpage20.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 21,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45034",
    price: 1590,
    img: "./images/menpage21.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 22,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45035",
    price: 1590,
    img: "./images/menpage22.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 23,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45038",
    price: 1590,
    img: "./images/menpage23.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 24,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45039",
    price: 1590,
    img: "./images/menpage24.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 25,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45040",
    price: 7250,
    img: "./images/menpage25.webp",
    color: "Dark",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 26,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45041",
    price: 2500,
    img: "./images/menpage26.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 27,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45042",
    price: 2500,
    img: "./images/menpage27.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 28,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45043",
    price: 2500,
    img: "./images/menpage28.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 29,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45044",
    price: 5890,
    img: "./images/menpage29.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 30,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45046",
    price: 5890,
    img: "./images/menpage30.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  ,
  {
    id: 31,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45047",
    price: 5890,
    img: "./images/menpage31.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 32,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45049",
    price: 5890,
    img: "./images/menpage32.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 33,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45050",
    price: 5890,
    img: "./images/menpage33.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },

  {
    id: 34,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45051",
    price: 5890,
    img: "./images/menpage34.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "men",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-45052",
    price: 5890,
    img: "./images/menpage35.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 36,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12053",
    price: 2500,
    img: "./images/women1.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 37,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12054",
    price: 1890,
    img: "./images/women2.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 38,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12055",
    price: 1890,
    img: "./images/women3.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 39,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12056",
    price: 5390,
    img: "./images/women4.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 40,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12057",
    price: 5390,
    img: "./images/women5.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 41,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12058",
    price: 5390,
    img: "./images/women6.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 42,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12059",
    price: 5390,
    img: "./images/women7.webp",
    color: "Bright",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 43,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12060",
    price: 5390,
    img: "./images/women8.webp",
    color: "Light",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 44,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12061",
    price: 5390,
    img: "./images/women9.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 45,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12062",
    price: 5390,
    img: "./images/women10.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },

  {
    id: 46,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12063",
    price: 5390,
    img: "./images/women11.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 47,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12064",
    price: 5390,
    img: "./images/women12.webp",
    color: "Light",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 48,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12066",
    price: 5390,
    img: "./images/women13.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 49,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12068",
    price: 5390,
    img: "./images/women14.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 50,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12069",
    price: 5390,
    img: "./images/women15.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12070",
    price: 5390,
    img: "./images/women16.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12074",
    price: 5390,
    img: "./images/women17.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12076",
    price: 5390,
    img: "./images/women18.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12078",
    price: 5390,
    img: "./images/women19.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "women",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-B-12080",
    price: 5390,
    img: "./images/women20.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73082",
    price: 5390,
    img: "./images/kidboys.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },

  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73083",
    price: 5390,
    img: "./images/kidboys2.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73084",
    price: 5390,
    img: "./images/kidboys3.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73085",
    price: 5390,
    img: "./images/kidboys4.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73086",
    price: 5390,
    img: "./images/kidboys5.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73087",
    price: 5390,
    img: "./images/kidboys6.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73088",
    price: 5390,
    img: "./images/kidboys7.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73089",
    price: 5390,
    img: "./images/kidboys8.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73090",
    price: 5390,
    img: "./images/kidboys9.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73091",
    price: 5390,
    img: "./images/kidboys10.webp",
    color: "Bright",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-730892",
    price: 5390,
    img: "./images/teenboys1.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73094",
    price: 5390,
    img: "./images/teenboys2.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73095",
    price: 5390,
    img: "./images/teenboys3.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73096",
    price: 5390,
    img: "./images/teenboys4.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73097",
    price: 5390,
    img: "./images/teenboys5.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73098",
    price: 5390,
    img: "./images/teenboys6.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73099",
    price: 5390,
    img: "./images/teenboys7.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "boys",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-C-73100",
    price: 5390,
    img: "./images/teenboys8.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24201",
    price: 5390,
    img: "./images/kidgirls1.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24202",
    price: 5390,
    img: "./images/kidgirls2.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24203",
    price: 5390,
    img: "./images/kidgirls3.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24203",
    price: 5390,
    img: "./images/kidgirls4.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24204",
    price: 5390,
    img: "./images/kidgirls5.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24205",
    price: 5390,
    img: "./images/kidgirls6.webp",
    color: "Dark",
    volume: "Summer 2022",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24206",
    price: 5390,
    img: "./images/kidgirls7.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24207",
    price: 5390,
    img: "./images/kidgirls8.webp",
    color: "Dark",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24208",
    price: 5390,
    img: "./images/kidgirls9.webp",
    color: "Bright",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24209",
    price: 5390,
    img: "./images/kidgirls10.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24210",
    price: 5390,
    img: "./images/kidgirls11.webp",
    color: "Light",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24211",
    price: 5390,
    img: "./images/teengirls.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24212",
    price: 5390,
    img: "./images/teengirls2.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24213",
    price: 5390,
    img: "./images/teengirls3.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24214",
    price: 5390,
    img: "./images/teengirls4.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24216",
    price: 5390,
    img: "./images/teengirls5.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24218",
    price: 5390,
    img: "./images/teengirls6.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24220",
    price: 5390,
    img: "./images/teengirls7.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24221",
    price: 5390,
    img: "./images/teengirls8.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "girls",
    category: "",
    title: "KAMEEZ SHALWAR",
    code: "JJKS-A-24222",
    price: 5390,
    img: "./images/teengirls9.webp",
    color: "Bright",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "LIPSTICK",
    code: "JJKS-D-92024",
    price: 5390,
    img: "./images/lips1.webp",
    color: "12",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "LIPSTICK",
    code: "JJKS-D-92025",
    price: 5390,
    img: "./images/lips2.webp",
    color: "12",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "LIPSTICK",
    code: "JJKS-D-92026",
    price: 5390,
    img: "./images/lips3.webp",
    color: "12",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "EYE-LINER",
    code: "JJKS-D-92027",
    price: 5390,
    img: "./images/eye1.webp",
    color: "12",
    volume: "Winter 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "EYE-LINER",
    code: "JJKS-D-92028",
    price: 5390,
    img: "./images/eye2.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "EYE-LINER",
    code: "JJKS-D-92029",
    price: 5390,
    img: "./images/eye3.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "SUN-SCREEN",
    code: "JJKS-D-92031",
    price: 5390,
    img: "./images/face1.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "SUN-SCREEN",
    code: "JJKS-D-92032",
    price: 5390,
    img: "./images/face2.webp",
    color: "12",
    volume: "Summer 2022",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "SUN-SCREEN",
    code: "JJKS-D-92034",
    price: 5390,
    img: "./images/face3.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92036",
    price: 5390,
    img: "./images/fragrance1.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92039",
    price: 5390,
    img: "./images/fragrance2.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92041",
    price: 5390,
    img: "./images/fragrance3.webp",
    color: "12",
    volume: "Winter 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92042",
    price: 5390,
    img: "./images/fragrance4.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92044",
    price: 5390,
    img: "./images/fragrance5.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Formal",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92045",
    price: 5390,
    img: "./images/fragrance6.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Semi-casual",
    collection: "",
  },
  {
    id: 35,
    page: "makeupandfragrances",
    category: "",
    title: "PERFUME",
    code: "JJKS-D-92046",
    price: 5390,
    img: "./images/fragrance7.webp",
    color: "12",
    volume: "Spring 2021",
    weartype: "Casual",
    collection: "",
  },

];
export default data;
